export default function IndustryDefaultIcon() {
	return (
		<svg
			width={56}
			height={57}
			viewBox='0 0 56 57'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M11.2 8.406a3.732 3.732 0 0 0-3.733 3.734v11.2a3.732 3.732 0 0 0 3.733 3.733h11.2a3.732 3.732 0 0 0 3.734-3.733v-11.2A3.732 3.732 0 0 0 22.4 8.406H11.2Zm22.4 0c-2.04 0-3.733 1.693-3.733 3.734v11.2c0 2.04 1.693 3.733 3.733 3.733h11.2c2.04 0 3.733-1.693 3.733-3.733v-11.2c0-2.04-1.693-3.734-3.733-3.734H33.6Zm0 3.734h11.2v11.2H33.6v-11.2ZM11.2 30.806c-2.04 0-3.733 1.693-3.733 3.734v11.2c0 2.04 1.693 3.733 3.733 3.733h11.2c2.04 0 3.734-1.693 3.734-3.733v-11.2c0-2.04-1.694-3.734-3.734-3.734H11.2Zm22.4 0c-2.04 0-3.733 1.693-3.733 3.734v11.2c0 2.04 1.693 3.733 3.733 3.733h11.2c2.04 0 3.733-1.693 3.733-3.733v-11.2c0-2.04-1.693-3.734-3.733-3.734H33.6ZM11.2 34.54h3.734a1.866 1.866 0 1 0 3.733 0H22.4v3.733a1.867 1.867 0 0 0 0 3.733v3.734h-3.733a1.867 1.867 0 0 0-3.734 0H11.2v-3.734a1.867 1.867 0 1 0 0-3.733V34.54Zm24.267 0h7.467v1.866H44.8v7.467h-1.866v1.867h-7.467v-1.867H33.6v-7.467h1.867V34.54Zm1.867 3.733v3.733h3.733v-3.733h-3.733Z'
				fill='#005AFF'
			/>
		</svg>
	)
}
